module.exports = __webpack_public_path__ + "static/img/Rory-Laird.013a03e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Rory-Laird.jpg
// module id = pG+9
// module chunks = 0